import FilterRegister from "../../../../components/filter/register-basic";
import reqPromocao from "../../../../services/reqMultiTenant/reqPromocao";
import { RegisterProvider } from "../../register-matrix/context-api";
import MainRegisterMatrix from "../../register-matrix/main";
import Form from "../form";

const MainRegisterPromotions = () => {
	const options = {
		id: "id_promocao", //usado para saber qual field usar para atualizar
		ident: "promotions", //usado para definir os event listners
		identFilter: "filterPromotions", //usado para definir os event listners
		title: "Gestão de Promoções e Cupons",
		subTitle: "Cadastro",
		notice: "Aqui você define as regras de desconto e cupons. Você pode criar cupons de valor fixo ou percentual, com validade e valor mínimo de compra.",
		tableColumns: [
			{ key: "descricao", label: "Descrição", align: "left" },
			{ key: "cod_cupom", label: "Cupom", align: "center" },
			{ key: "inicio", label: "Início", align: "center", format: "date" },
			{ key: "fim", label: "Fim", align: "center", format: "date" },
			{ key: "status", label: "Status", align: "center", format: "badgeStatus" },
			{ key: "actions", label: "", align: "right" },
		],
		hasActive: true,
		parametersFilter: [
			{ id: 1, label: "Descrição", value: "descricao" },
			{ id: 2, label: "Código Cupom", value: "cod_cupom" },
		],
	};

	const fetch = async (filterData, newPage) => {
		const { param, paramValue, active } = filterData;

		const response = await reqPromocao.listPaginate(param, paramValue, active, newPage);

		return response;
	};

	const fetchID = async (currentId) => {
		const response = await reqPromocao.listID(currentId);
		return response;
	};

	const insert = async (data) => {
		const response = await reqPromocao.insert(data);
		return response;
	};

	return (
		<RegisterProvider options={options} fetch={fetch} fetchID={fetchID} insert={insert}>
			<MainRegisterMatrix FormComponent={Form} FormFilter={FilterRegister} />
		</RegisterProvider>
	);
};

export default MainRegisterPromotions;
